import type { TFunction } from 'i18next'
import { ROUTES } from '@/lib/routes'
import { apiErrorMessage } from '@/lib/checkout/outcome'

/** The export id of `/privacy/exports/{id}` (as the F-200 e-mail writes it) or `/_/privacy/exports/{id}`, else `null`. */
export const privacyExportIdOf = (path: string): string | null => {
  const clean = path.split(/[?#]/)[0]
  const rest = clean.startsWith(ROUTES.privacyExport)
    ? clean.slice(ROUTES.privacyExport.length)
    : clean.startsWith(`/_${ROUTES.privacyExport}`) ? clean.slice(ROUTES.privacyExport.length + 2) : null
  const id = rest?.split('/')[0]
  return id ? decodeURIComponent(id) : null
}

/**
 * F-200: the refusals of asking an export, in the reader's language and time
 * zone: 409 one still being built, 429 the 24 h wait (`data.nextAvailableAt`).
 * Anything else is the API's sentence (wrong password, no password, role).
 */
export const exportRefusalText = (err: unknown, t: TFunction, formatDateTime: (d: string) => string): string => {
  const { status, message, data } = apiErrorMessage(err)
  if (status === 409) return t('privacy:export.inProgress')
  const next = (data as { nextAvailableAt?: string } | null)?.nextAvailableAt
  if (status === 429 && next) return t('privacy:export.tooSoon', { date: formatDateTime(next) })
  return message || t('privacy:erasure.error')
}
